import { css } from "@styled-system/css";

export const linkClass = css({
	textDecoration: "underline",
});
